/* Nagi cart — the header count, and the theme's own drawer when it is on. */

/* ---- The count beside the cart icon ------------------------------------
   Liquid prints it once, which stays true only until the first add. The cart
   belongs to an app whose drawer never reloads the page, so the number sat
   stale — and on an empty cart the bubble stayed away — until the shopper
   navigated somewhere.

   Binding to one app's events would tie this to that app. The cart endpoints
   are the thing every app has in common instead: an add, a change, an update
   or a clear all pass through fetch or XHR, and each is followed here by a
   read of /cart.js, which is the only number worth believing. Apps that do
   announce themselves with an event are listened to as well; it costs
   nothing and arrives a little sooner. */
(function () {
  var WRITES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function paint(n) {
    var el = document.querySelector('.nagi-cart-btn__count');
    if (!el) return;
    /* Empty rather than "0": the stylesheet hides an empty bubble, so the
       circle leaves with the last item and comes back with the next one. */
    var text = n > 0 ? String(n) : '';
    if (el.textContent !== text) el.textContent = text;
  }

  var queued = false;
  function sync() {
    if (queued) return;
    queued = true;
    /* A beat, because apps chain their calls — add, then update for a deal —
       and the count is worth reading once, after the last of them. */
    setTimeout(function () {
      queued = false;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { paint(cart.item_count); })
        .catch(function () {});
    }, 300);
  }

  try {
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var out = nativeFetch.apply(this, arguments);
        /* The caller still gets the original promise; this is a branch off
           it, with its own rejection handler so nothing is left unhandled. */
        if (WRITES.test(url)) out.then(sync, function () {});
        return out;
      };
    }
  } catch (e) {}

  try {
    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype) {
      var nativeOpen = XHR.prototype.open;
      XHR.prototype.open = function (method, url) {
        try { this.__nagiCartWrite = WRITES.test(String(url || '')); } catch (e) {}
        return nativeOpen.apply(this, arguments);
      };
      var nativeSend = XHR.prototype.send;
      XHR.prototype.send = function () {
        if (this.__nagiCartWrite) this.addEventListener('loadend', sync);
        return nativeSend.apply(this, arguments);
      };
    }
  } catch (e) {}

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:built'].forEach(function (name) {
    document.addEventListener(name, sync);
  });

  /* Back from the history cache with a cart that may have moved on since. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();

/* ---- The theme's own drawer — open/close, quantities, add-to-cart --------
   Off while a cart app owns the cart: the layout then renders no #nagi-drawer
   and everything below stands down, leaving the app's own handlers alone. */
(function () {
  var drawer = document.getElementById('nagi-drawer');
  if (!drawer) return;

  function open() {
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* Re-fetch the drawer markup from the server so Liquid stays the source of
     truth for pricing, the free-shipping bar and line rendering. */
  function refresh(thenOpen) {
    return fetch(window.location.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('nagi-drawer');
        if (next) {
          var wasHidden = drawer.hidden;
          drawer.innerHTML = next.innerHTML;
          drawer.hidden = thenOpen ? false : wasHidden;
          if (thenOpen) document.documentElement.style.overflow = 'hidden';
        }
        var count = doc.querySelector('.nagi-cart-btn__count');
        var live = document.querySelector('.nagi-cart-btn__count');
        if (count && live) live.textContent = count.textContent;
      });
  }

  /* Delegated events so re-rendered markup keeps working. */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('.nagi-cart-btn');
    if (cartBtn) {
      e.preventDefault();
      refresh(true);
      return;
    }

    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var qtyBtn = e.target.closest('.nagi-line__qty button');
    if (qtyBtn) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: qtyBtn.dataset.key, quantity: parseInt(qtyBtn.dataset.qty, 10) })
      }).then(function () { refresh(false); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* Intercept add-to-cart forms so the drawer opens instead of navigating. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.querySelector('[name="checkout"]')) return;

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = (window.nagiStrings && window.nagiStrings.cart_adding) || 'Dedama…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });
})();
